// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useMemo, useState } from "react";
import { PayloadMismatchError, PayloadProblem, payloadToSign, signedView, } from "@/lib/signing/request";
var problemOf = function (error) {
    return error instanceof PayloadMismatchError ? error.problem : PayloadProblem.Mismatch;
};
/** The request as its canonical payload describes it (see `signedView`). */
export var useSignedView = function (data) {
    var _a;
    var checked = useMemo(function () {
        try {
            return { view: signedView(data), problem: null };
        }
        catch (error) {
            return { view: null, problem: problemOf(error) };
        }
    }, [data]);
    var _b = useState(), digest = _b[0], setDigest = _b[1];
    useEffect(function () {
        var current = true;
        payloadToSign(data).then(function () { return current && setDigest({ data: data, problem: null }); }, function (error) { return current && setDigest({ data: data, problem: problemOf(error) }); });
        return function () {
            current = false;
        };
    }, [data]);
    var digestProblem = (digest === null || digest === void 0 ? void 0 : digest.data) === data ? digest.problem : null;
    return {
        view: checked.view,
        problem: (_a = checked.problem) !== null && _a !== void 0 ? _a : digestProblem,
        verified: !checked.problem && (digest === null || digest === void 0 ? void 0 : digest.data) === data && !digest.problem,
    };
};
/** The translation key telling the signer why the request can't be signed as shown. */
export var problemMessage = function (problem) {
    return problem === PayloadProblem.Document
        ? "signing.widget.documentMismatch"
        : "signing.widget.mismatch";
};
